import { type ReactNode } from "react";

import { getMobileNavClearance } from "./mobileNavClearance";

/** Floating feedback button (size-12 = 48px) plus an 8px gap, kept clear at scroll end. */
const FEEDBACK_BUTTON_CLEARANCE = 56;

export const MobileContent = ({ children }: { children: ReactNode }) => (
  <main
    className="max-w-screen-xl mx-auto pt-18 px-4 min-h-screen overflow-y-auto"
    style={{
      paddingBottom: getMobileNavClearance() + FEEDBACK_BUTTON_CLEARANCE,
    }}
    id="main-content"
  >
    {children}
  </main>
);
